import React from 'react';
import { Helmet } from 'react-helmet-async';

const Section: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <section className="mb-10">
    <h2 className="mb-4 text-2xl font-semibold text-slate-900 dark:text-white">{title}</h2>
    <div className="space-y-4 text-slate-600 dark:text-zinc-400">{children}</div>
  </section>
);

const RefundPolicy: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Refund Policy - OmniScribe</title>
        <meta name="description" content="OmniScribe Refund Policy" />
      </Helmet>

      <div className="min-h-screen bg-white py-16 transition-colors duration-300 dark:bg-zinc-950">
        <div className="container mx-auto max-w-4xl px-4">
          <h1 className="h-hero mb-4">Refund Policy</h1>
          <p className="mb-12 text-slate-500 dark:text-zinc-400">Last updated: May 9, 2026</p>

          <div className="prose prose-slate max-w-none dark:prose-invert">
            <Section title="Overview">
              <p>
                This Refund Policy explains when NanoUltra, LLC may issue refunds for paid OmniScribe
                subscriptions. It applies to subscription fees paid for OmniScribe plans unless a separate
                written agreement says otherwise.
              </p>
            </Section>

            <Section title="Monthly Subscriptions">
              <p>
                If you have not used any transcription minutes during the current billing period, you may
                request a refund for that billing period.
              </p>
            </Section>

            <Section title="Annual Subscriptions">
              <p>
                We can refund the unused portion of your subscription on a prorated basis, calculated based on
                the remaining time in your subscription term.
              </p>
            </Section>

            <Section title="How to Request a Refund">
              <p>
                If you believe you are eligible for a refund, please contact us at{' '}
                <a
                  href="mailto:support@omniscribe.ai"
                  className="font-medium text-indigo-600 underline underline-offset-2 hover:text-indigo-700 dark:text-indigo-400 dark:hover:text-indigo-300"
                >
                  support@omniscribe.ai
                </a>{' '}
                and we will be happy to help.
              </p>
              <p>
                Please include the email address associated with your OmniScribe account and any relevant
                billing details so we can review your request.
              </p>
            </Section>
          </div>
        </div>
      </div>
    </>
  );
};

export default RefundPolicy;
